import { createContext } from 'react';
export const DossierContext = createContext({
    placeholderContextValue: true,
});
DossierContext.displayName = 'DossierContext';
//# sourceMappingURL=DossierContext.js.map